import { NotificationTemplate } from "../index";

export const Collaborators: NotificationTemplate<undefined> = {
  renderTitle: props => "Add new contractors",
  renderBody: props => {
    return "Add new contractors so you can get started working together.";
  },
  buttonAction: (props, history) => () => {
    return history.push("/member/payees");
  },
  buttonText: () => "Add new contractors"
};
